module.exports = __webpack_public_path__ + "static/media/Panchmahal.f2cf02cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Panchmahal.png
// module id = 997
// module chunks = 0